'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAuth } from '@clerk/nextjs';
import logo from '@public/logo-with-text.svg';
import mock from '@public/mock.svg';
import Image from 'next/image';
import { useTranslation } from '../i18n/client';
import { useParams, useRouter } from 'next/navigation';
import { classNames } from '@/helpers/utilities';
import { Button } from '@/components/button';
export default function Home() {
  const $ = _c(70);
  const {
    lng
  } = useParams();
  const {
    t
  } = useTranslation(lng, "home");
  const router = useRouter();
  const {
    isSignedIn,
    isLoaded
  } = useAuth();
  let t0;
  let t1;
  if ($[0] !== isLoaded || $[1] !== isSignedIn || $[2] !== lng || $[3] !== router) {
    t0 = () => {
      if (isLoaded && isSignedIn) {
        router.replace(`/${lng}/dashboard`);
      }
    };
    t1 = [isLoaded, isSignedIn, lng, router];
    $[0] = isLoaded;
    $[1] = isSignedIn;
    $[2] = lng;
    $[3] = router;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== t) {
    t2 = t("label");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <p className="mb-2 text-5xl">{t2}</p>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t("subLabel");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <p className="mb-4 text-2xl">{t4}</p>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src={mock} alt="Illustration showing the docomondo budgeting dashboard with charts and cards" height={400} />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t5) {
    t7 = <div className="flex flex-col items-center justify-center text-center text-white">{t3}{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute -right-16 h-full w-24"><svg className="h-full w-full fill-white" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0 0 Q 50 50 0 100 L 100 100 L 100 0 Z" /></svg></div>;
    t9 = <div className="h-44 w-full" />;
    $[18] = t8;
    $[19] = t9;
  } else {
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t7) {
    t10 = <div className="bg-cPrimary relative flex w-6/12 flex-1 flex-col items-center justify-center">{t7}{t8}{t9}</div>;
    $[20] = t7;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="flex w-full flex-row items-center justify-end p-4"><Image src={logo} alt="Logo of docomondo" height={35} /></div>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = lng === "de" ? "text-cPrimary underline" : "text-gray-400";
  let t13;
  if ($[23] !== t12) {
    t13 = classNames("mr-2 ml-2", t12);
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13) {
    t14 = <a className={t13} href="de">{"de"}</a>;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = lng === "en" ? "text-cPrimary underline" : "text-gray-400";
  let t16;
  if ($[27] !== t15) {
    t16 = classNames("mr-2 ml-2", t15);
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16) {
    t17 = <a className={t16} href="en">{"en"}</a>;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t14 || $[32] !== t17) {
    t18 = <div className="mb-4 flex flex-row gap-2">{t14}{t17}</div>;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t) {
    t19 = t("welcomeTo");
    $[34] = t;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <a className="text-cPrimary hover:underline" href="https://docomondo.com" target="_blank" rel="noreferrer">{" docomondo!"}</a>;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19) {
    t21 = <div className="flex flex-col items-center justify-center text-center"><p className="mb-4 ml-16 text-5xl no-underline">{t19}{t20}</p></div>;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== router) {
    t22 = () => router.push("/sign-in");
    $[39] = router;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t) {
    t23 = t("login");
    $[41] = t;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== t22 || $[44] !== t23) {
    t24 = <Button className="w-full" onClick={t22}>{t23}</Button>;
    $[43] = t22;
    $[44] = t23;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== router) {
    t25 = () => router.push("/sign-up");
    $[46] = router;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t) {
    t26 = t("signUp");
    $[48] = t;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  let t27;
  if ($[50] !== t25 || $[51] !== t26) {
    t27 = <Button className="w-full" outline={true} onClick={t25}>{t26}</Button>;
    $[50] = t25;
    $[51] = t26;
    $[52] = t27;
  } else {
    t27 = $[52];
  }
  let t28;
  if ($[53] !== t24 || $[54] !== t27) {
    t28 = <div className="flex flex-col items-center gap-2">{t24}{t27}</div>;
    $[53] = t24;
    $[54] = t27;
    $[55] = t28;
  } else {
    t28 = $[55];
  }
  let t29;
  if ($[56] !== t18 || $[57] !== t21 || $[58] !== t28) {
    t29 = <div className="flex flex-1 flex-col items-center justify-center">{t18}{t21}{t28}</div>;
    $[56] = t18;
    $[57] = t21;
    $[58] = t28;
    $[59] = t29;
  } else {
    t29 = $[59];
  }
  let t30;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div />;
    $[60] = t30;
  } else {
    t30 = $[60];
  }
  let t31;
  if ($[61] !== t29) {
    t31 = <div className="flex min-h-screen flex-1 flex-col items-center justify-between">{t11}{t29}{t30}</div>;
    $[61] = t29;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t10 || $[64] !== t31) {
    t32 = <div className="flex flex-1 flex-row bg-white">{t10}{t31}</div>;
    $[63] = t10;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <p>Powered by Docomondo</p>;
    $[66] = t33;
  } else {
    t33 = $[66];
  }
  let t34;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <footer className="border-t-cWhiteSmoke flex flex-1 items-center justify-center border-t border-solid px-0 py-8">{t33}<div className="ml-2"><Image src={logo} alt="Logo of docomondo" width={35} height={35} style={{
          maxWidth: "100%",
          height: "auto"
        }} /></div></footer>;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  let t35;
  if ($[68] !== t32) {
    t35 = <div>{t32}{t34}</div>;
    $[68] = t32;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  return t35;
}